import slideHorizontalView from './slideHorizontalComponent.html';
import './slideHorizontalComponent.css';
import _ from 'lodash';

export function slideHorizontalComponent() {
	return {
		bindings: {
			slidePixels: '<',
			reload: '<',
			hasWidthChanged: '<',
			onReachedRight: '&?',
		},
		transclude: true,
		controllerAs: 'vm',
		controller: slideHorizontalComponentCtrl,
		template: slideHorizontalView,
	};
}

export class slideHorizontalComponentCtrl {
	constructor($element, $scope, $timeout) {
		'ngInject';
		this.$element = $element;
		this.$scope = $scope;
		this.$timeout = $timeout;
	}

	$onInit() {
		this.horizontalContentEl = this.$element[0].querySelector('.horizontal-content-section');
		this.pixelsPerSlide = this.slidePixels;
		this.contentPosition = 0;
		this.canNavRight = true;
		this.canNavLeft = false;

		this.clientWidth = document.documentElement.clientWidth;
		this.contentWidth = undefined;
		this.widthDifference = undefined;
		this.$scope.$watch('vm.reload', () => {
			this.contentPosition = 0;
			this.updateWidthCalculations();
		});
		this.$scope.$watch('vm.hasWidthChanged', () => {
			this.$timeout(() => this.updateWidthCalculations(), 50);
		});
		this.throttleResize = _.throttle(this.updateOnScreenResize.bind(this), 150);
		window.addEventListener('resize', this.throttleResize);
	}

	$onDestroy() {
		window.removeEventListener('resize', this.throttleResize);
	}

	/**
	 * Client width will have changed, so need to check if sliding right is available now
	 */
	updateOnScreenResize() {
		this.clientWidth = document.documentElement.clientWidth;
		// contentWidth won't be set if the user resizes the window before having navigated to the right
		this.contentWidth = this.contentWidth !== undefined ? this.contentWidth : this.horizontalContentEl.scrollWidth;
		this.widthDifference = this.contentWidth - this.clientWidth;
		this.updateCanNavRight();
	}

	updateCanNavRight() {
		this.canNavRight = Math.abs(this.contentPosition) <= this.widthDifference;
	}

	updateCanNavLeft() {
		this.canNavLeft = this.contentPosition < 0;
	}

	/**
	 * If content width has changed since the last time (i.e., content added or removed), recalculate other measurements
	 */
	updateWidthCalculations() {
		const currentContentWidth = this.horizontalContentEl.scrollWidth;
		if (currentContentWidth != this.contentWidth) {
			this.contentWidth = currentContentWidth;
			this.widthDifference = this.contentWidth - this.clientWidth;
		}
		this.updateCanNavRight();
	}

	slideLeft($event) {
		// shift + click goes to the far left
		this.canNavRight = true;
		if ($event && $event.shiftKey) {
			this.contentPosition = 0;
			this.canNavLeft = false;
		} else {
			this.contentPosition += this.contentPosition >= 0 ? 0 : this.pixelsPerSlide;
			this.updateCanNavLeft();
		}
	}

	slideRight($event) {
		// shift + click goes to the far right
		if ($event && $event.shiftKey) {
			this.contentPosition = -this.widthDifference;
			this.canNavRight = false;
		} else {
			// don't slide if already at the end of the sliding section
			this.contentPosition -= this.pixelsPerSlide;
			// after sliding, see if there is any more room to nav right
			this.updateCanNavRight();
		}
		this.canNavLeft = true;
		if (!this.canNavRight && this.onReachedRight) {
			this.onReachedRight();
		}
	}
}
